import { Box, Button, CircularProgress, FormControl, Grid, Paper, Typography } from "@mui/material";
import { format } from 'date-fns';
import { useSnackbar } from "notistack";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../../app/store";

import configUrls from "../../../config/configUrls";
import { ProcessoHistoricoAndamentoList } from "../../../types/processo/ProcessoHistoricoAndamentoList";
import { useGetProcessoHistoricosQuery } from "../processoApiSlice";





export const ProcessoAndamentoListForm = () => {

    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate(); // Hook para navegação



    const [andamentos, setAndamentos] = useState<ProcessoHistoricoAndamentoList[]>([]);


    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
    useEffect(() => {
        if (!processoSelecionado) {
            alert("Nenhum processo selecionado");
            window.location.href = configUrls.PROCESSO_LIST_RT
        }
    }, [processoSelecionado]);


    const { data, isFetching, error } = useGetProcessoHistoricosQuery(processoSelecionado?.id ?? "");

    useEffect(() => {
        if (data) {
            setAndamentos(data);
        }
        if (error) {
            enqueueSnackbar("Andamentos não encontradas!", { variant: "error" });
        } else if (isFetching) {
            enqueueSnackbar("Buscando registros...", { variant: "info" });
        }
    }, [data, error, isFetching, enqueueSnackbar]);


    if (isFetching) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }
    const headerGerados = (
        <Typography variant="body2" color="textSecondary">
            Andamento(s) encontrados(s): {andamentos.length}
        </Typography>
    );


    const renderData = (rowData: ProcessoHistoricoAndamentoList) => {
        const dataCriacao = rowData.dataHoraCriacao ? format(rowData.dataHoraCriacao, 'dd/MM/yyyy HH:mm:ss') : "Data não disponível";
        return <Typography color="secondary" variant="body2">{dataCriacao}</Typography>;
    };

    const renderUsuario = (rowData: ProcessoHistoricoAndamentoList) => (
        <Typography color="secondary" variant="body2">{rowData.usuario?.nome || "Usuário não disponível"}</Typography>
    );
    const renderDescricao = (rowData: ProcessoHistoricoAndamentoList) => (
        <Typography color="secondary" variant="body2">{rowData.descricao || ""}</Typography>
    );


    return (
        <>

            <Paper sx={{ width: "100%", height: "100vh", padding: "12px" }}>
                <Grid container padding={2}>
                    <Grid item xs={12}>
                        <FormControl fullWidth>

                            <Box display="flex" justifyContent="space-between" mb={2}>

                                <Box display="flex">
                                    <Typography color="secondary" variant="h6" gutterBottom>
                                        Andamentos para o processo: {processoSelecionado?.numeroProcesso}
                                    </Typography>
                                </Box>


                                <Box display="flex" justifyContent="flex-end" gap={2}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => { navigate(configUrls.PROCESSO_HISTORICO_CREATE_RT) }}
                                    >
                                        Novo
                                    </Button>

                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => navigate(-1)}
                                    >
                                        Voltar
                                    </Button>


                                </Box>
                            </Box>




                        </FormControl>
                    </Grid>
                </Grid>

                <DataTable
                    value={andamentos}
                    paginator
                    rows={25}
                    showGridlines={true}
                    size="small"
                    columnResizeMode="expand"
                    resizableColumns
                    dataKey="id"
                    header={headerGerados}
                    className="custom-datatable"
                >

                    <Column header="Data" body={renderData} sortable style={{ width: '20%' }} />
                    <Column header="Descrição" body={renderDescricao} sortable style={{ width: '70%' }} />
                    <Column header="Usuário" body={renderUsuario} sortable style={{ width: '20%' }} />


                </DataTable>


            </Paper>

        </>







    );










};
